<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>
    <div class="center" fusePerfectScrollbar>

        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">

            <div class="mat-display-1 my-0 my-sm-24 welcome-message">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'REPORT_LIST' |translate}}</span>
            </div>

            <div class="search-wrapper  ml-sm-32">
            </div>

        </div>

        <div>
            <div class="content-card p-20">
                <mat-card style="padding: 0 !important;">
                    <div class="p-20 table-select-style" fxLayout="row" fxLayoutAlign="space-between center">
                        <mat-card-title class="custom-card-title" fxFlex="70">{{'CONTAINER_UNLOADING_REPORT' | translate}}</mat-card-title>
                        <div fxLayout="row" fxLayoutGap="5px" fxLayoutGap.gt-sm="10px">
                            <button mat-mini-fab [matMenuTriggerFor]="menuUnloadingFilter">
                                <mat-icon>tune</mat-icon>
                            </button>
                            <mat-menu #menuUnloadingFilter="matMenu">
                                <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'DEVICE'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="selectUnloadingDevice" multiple>
                                            <mat-option *ngFor="let container of containerAllList"
                                                (click)="onUnloadingDeviceSelect()" [value]="container.deviceId">
                                                {{container.deviceId}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div mat-menu-item style="height: 75px;"  (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'CHOOSE_DATE'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="selectByFilter">
                                            <mat-option (click)="onContainerUnloadingStatusClick('day')" value="day">
                                                {{'TODAY'|translate}}
                                            </mat-option>
                                            <mat-option (click)="onContainerUnloadingStatusClick('week')" value="week">
                                                {{'THIS_WEEK'|translate}}
                                            </mat-option>
                                            <mat-option (click)="onContainerUnloadingStatusClick('month')" value="month">
                                                {{'THIS_MONTH'|translate}}
                                            </mat-option>
                                            <mat-option [matMenuTriggerFor]="menu" value="special">
                                                {{'OTHER'|translate}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-menu #menu="matMenu">
                                        <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>{{'START_DATE'|translate}}</mat-label>
                                                <input matInput [ngxMatDatetimePicker]="startpicker" name="startpicker"
                                                    placeholder="{{'START_DATE'|translate}}" [(ngModel)]="StartTime" required>
                                                <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #startpicker>
                                                    <ng-template>
                                                        <span>OK</span>
                                                    </ng-template>
                                                </ngx-mat-datetime-picker>
                                            </mat-form-field>
                                        </div>
                                        <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>{{'END_DATE'|translate}}</mat-label>
                                                <input matInput [ngxMatDatetimePicker]="endRatePicker" name="endRatePicker"
                                                    placeholder="{{'END_DATE'|translate}}" [(ngModel)]="EndTime" required>
                                                <mat-datepicker-toggle matSuffix [for]="endRatePicker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #endRatePicker>
                                                    <ng-template>
                                                        <span>OK</span>
                                                    </ng-template>
                                                </ngx-mat-datetime-picker>
                                            </mat-form-field>
                                        </div>
                                        <div mat-menu-item
                                            (click)="StartTime && EndTime ?onContainerUnloadingStatusClick('special',StartTime,EndTime):$event.stopPropagation()">
                                            OK
                                        </div>
                                    </mat-menu>
                                </div>
                            </mat-menu>
                            <button mat-mini-fab (click)="onReportClick()">
                                <mat-icon>cloud_download</mat-icon>
                            </button>
                        </div>

                    </div>
                    <div class="p-20 pt-0" style="overflow: auto;" fusePerfectScrollbar>
                        <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px; min-width: 700px;" #table matSortActive="beforeDate"
                        matSortDirection="desc"
                            [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}">

                            <ng-container matColumnDef="containerName">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'CONTAINER' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.containerName!=null?device.containerName:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="deviceId">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'DEVICE_ID' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.deviceId!=null?device.deviceId:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="beforeDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>Boşaltılmadan Önce Tarih
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.beforeDate!=null?(device.beforeDate |date:'dd.MM.yyyy HH:mm') :"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="afterDate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>Boşaltılmadan Sonra Tarih
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.afterDate!=null?(device.afterDate |date:'dd.MM.yyyy HH:mm') :"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="beforeOccupancy">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'BEFORE_OCCUPANCY'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.beforeOccupancy!=null?device.beforeOccupancy:'---'}} %
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="afterOccupancy">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'AFTER_OCCUPANCY'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.afterOccupancy!=null?device.afterOccupancy:'---'}} %
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="address">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'ADDRESS'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.address!=null?device.address:"---"}}
                                </mat-cell>
                            </ng-container>


                            <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                            <mat-row *matRowDef="let device; columns: displayedColumns;" class="order" matRipple>
                            </mat-row>
                        </mat-table>

                        <mat-paginator style="min-width: 700px;" #paginator [length]="paginator.length" [pageSize]="10"
                            [pageSizeOptions]="[10, 50, 100]">
                        </mat-paginator>
                    </div>
                    <mat-progress-bar [fxShow]="tableLoading" style="border-radius: 10px;" mode="indeterminate">
                    </mat-progress-bar>
                </mat-card>

            </div>

            <div class="content-card p-20">
                <mat-card style="padding: 0 !important;">
                    <div class="p-20 table-select-style" fxLayout="row" fxLayoutAlign="space-between center">
                        <mat-card-title class="custom-card-title" fxFlex="70">{{'Konteyner Boşaltım Oran Raporu' | translate}}</mat-card-title>
                        <div fxLayout="row" fxLayoutGap="5px" fxLayout.gt-sm="10px">
                            <button mat-mini-fab [matMenuTriggerFor]="menuUnloadingRateFilter">
                                <mat-icon>tune</mat-icon>
                            </button>
                            <mat-menu #menuUnloadingRateFilter="matMenu">
                                <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'DEVICE'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="selectUnloadingRateDevice" multiple>
                                            <mat-option *ngFor="let container of containerAllList" (click)="onUnloadingRateSelect()"
                                                [value]="container.deviceId">{{container.deviceId}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div mat-menu-item style="height: 75px;"  (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'CHOOSE_DATE'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="selectByRateFilter">
                                            <mat-option (click)="onContainerUnloadingEmptyFullRateClick('day')" value="day">
                                                {{'TODAY'|translate}}
                                            </mat-option>
                                            <mat-option (click)="onContainerUnloadingEmptyFullRateClick('week')" value="week">
                                                {{'THIS_WEEK'|translate}}
                                            </mat-option>
                                            <mat-option (click)="onContainerUnloadingEmptyFullRateClick('month')" value="month">
                                                {{'THIS_MONTH'|translate}}
                                            </mat-option>
                                            <mat-option [matMenuTriggerFor]="menuRate" value="special">
                                                {{'OTHER'|translate}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-menu #menuRate="matMenu">
                                        <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>{{'START_DATE'|translate}}</mat-label>
                                                <input matInput [ngxMatDatetimePicker]="startRatePicker" name="startRatePicker"
                                                    placeholder="{{'START_DATE'|translate}}" [(ngModel)]="StartRateTime" required>
                                                <mat-datepicker-toggle matSuffix [for]="startRatePicker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #startRatePicker>
                                                    <ng-template>
                                                        <span>OK</span>
                                                    </ng-template>
                                                </ngx-mat-datetime-picker>
                                            </mat-form-field>
                                        </div>
                                        <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>{{'END_DATE'|translate}}</mat-label>
                                                <input matInput [ngxMatDatetimePicker]="endRatepicker" name="endpicker"
                                                    placeholder="{{'END_DATE'|translate}}" [(ngModel)]="EndRateTime" required>
                                                <mat-datepicker-toggle matSuffix [for]="endRatepicker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #endRatepicker>
                                                    <ng-template>
                                                        <span>OK</span>
                                                    </ng-template>
                                                </ngx-mat-datetime-picker>
                                            </mat-form-field>
                                        </div>
                                        <div mat-menu-item
                                            (click)="StartRateTime && EndRateTime ?onContainerUnloadingEmptyFullRateClick('special',StartRateTime,EndRateTime):$event.stopPropagation()">
                                            OK
                                        </div>
                                    </mat-menu>
                                </div>
                            </mat-menu>
                            <button mat-mini-fab (click)="onReportRateClick()">
                                <mat-icon>cloud_download</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div class="px-20 pb-20 w-100-p">
                        <div id="FullEmptyPieChart">
                            <apx-chart
                              [series]="fullEmptyPieChartOptions.series"
                              [chart]="fullEmptyPieChartOptions.chart"
                              [labels]="fullEmptyPieChartOptions.labels"
                              [legend]="fullEmptyPieChartOptions.legend"
                              [colors]="fullEmptyPieChartOptions.colors"
                              [responsive]="fullEmptyPieChartOptions.responsive"
                            ></apx-chart>
                          </div>
                    </div>
                    <div class="p-20 pt-0" style="overflow: auto;" fusePerfectScrollbar>
                        <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px; min-width: 700px;" #table
                            [dataSource]="dataSourceRate" #sortRate="matSort" matSort [@animateStagger]="{value:'50'}">

                            <ng-container matColumnDef="deviceId">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'DEVICE_ID' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.deviceId!=null?device.deviceId:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="emptyOccupancyCount">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'EMPTY_UNLOADING_COUNT'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.emptyOccupancyCount!=null?device.emptyOccupancyCount:'---'}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="fullOccupancyCount">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'FULL_UNLOADING_COUNT'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.fullOccupancyCount!=null?device.fullOccupancyCount:'---'}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="emptyRate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'EMPTY_UNLOADING_RATE'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.emptyRate!=null?(device.emptyRate | number : '1.2-2'):'---'}} %
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="fullRate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'FULL_UNLOADING_RATE'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.fullRate!=null?(device.fullRate | number : '1.2-2'):'---'}} %
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="count">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TOTAL_UNLOADING_COUNT'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.count!=null?device.count:'---'}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="address">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'ADDRESS'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.address!=null?device.address:"---"}}
                                </mat-cell>
                            </ng-container>


                            <mat-header-row *matHeaderRowDef="displayedColumnsRate; sticky:true"></mat-header-row>
                            <mat-row *matRowDef="let device; columns: displayedColumnsRate;" class="order" matRipple>
                            </mat-row>
                        </mat-table>

                        <mat-paginator style="min-width: 700px;" #paginatorU [length]="paginatorU.length" [pageSize]="10"
                            [pageSizeOptions]="[10, 50, 100]">
                        </mat-paginator>
                    </div>
                </mat-card>

            </div>
            
        </div>

    </div>
</div>